<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary"/>
    </v-overlay>

    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData[0],
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData[0] = $event"
        v-on:new="createHandler"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
        v-on:profile="formData[0].pic = $event"
        v-on:error="errorHandler"
      />

      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>

      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import familyForm from "../../../components/personnel/family/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": familyForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('recfamdetails.editfamdetails'),
      formData: [],
      errMsg: "",
      confirmMsg: "",
      isErr: false,
      loading: true,
      editMode: true,
      isConfirm: false,
    };
  },

  methods: {
    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      var payload = this.formData[0];

      this.$store.dispatch('put', {url: "/family/" + vm.id, payload: payload})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "familylist", params: { search: this.search}  });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    cancelHandler() {
      this.$router.push({ name: "familylist" });
    },

    deleteHandler($event) {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.isConfirm = !this.isConfirm;

      if ($event) {
        this.$store.dispatch('delete', {url:
              "/family/" +
              this.id +
              "/" +
              this.formData[0].userid})
          .then((res) => {
            if (res.data.error) {
              vm.isErr = !vm.isErr;
              vm.errMsg = res.data.error;
            } else {
              this.$router.push({ name: "familylist" });
            }
          })
          .catch((err) => {
            vm.isErr = !vm.isErr;
            vm.errMsg = err;
          });
      }
    },

    createHandler() {
      this.$router.push({ name: "familynew" });
    },

    loadFamilyHandler() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/family/" + vm.id})

        .then((res) => {
          if (res.status == 200) {
            vm.formData = res.data.rec;
            vm.pageTitleValue = vm.formData[0].psnname;

            if (vm.formData[0].dob) {
              vm.formData[0].dob = moment(vm.formData[0].dob).format(
                "YYYY-MM-DD"
              );
            }

            if (vm.formData[0].startdate) {
              vm.formData[0].startdate = moment(
                vm.formData[0].startdate
              ).format("YYYY-MM-DD");
            }

            if (vm.formData[0].enddate) {
              vm.formData[0].enddate = moment(vm.formData[0].enddate).format(
                "YYYY-MM-DD"
              );
            }

            if (vm.formData[0].isSpouse == "Y") {
              vm.formData[0].isSpouse = 1;
              vm.formData[0].isSpousedesc = "Y";
            } else {
              vm.formData[0].isSpouse = 0;
              vm.formData[0].isSpousedesc = "N";
            }

            if (vm.formData[0].isHandicap == "Y") {
              vm.formData[0].isHandicap = 1;
              vm.formData[0].isHandicapdesc = "Y";
            } else {
              vm.formData[0].isHandicap = 0;
              vm.formData[0].isHandicapdesc = "N";
            }

            if (vm.formData[0].isWorking == "Y") {
              vm.formData[0].isWorking = 1;
              vm.formData[0].isWorkingdesc = "Y";
            } else {
              vm.formData[0].isWorking = 0;
              vm.formData[0].isWorkingdesc = "N";
            }

            if (vm.formData[0].isStudying == "Y") {
              vm.formData[0].isStudying = 1;
              vm.formData[0].isStudyingdesc = "Y";
            } else {
              vm.formData[0].isStudying = 0;
              vm.formData[0].isStudyingdesc = "N";
            }

            if (vm.formData[0].isOversea == "Y") {
              vm.formData[0].isOversea = 1;
              vm.formData[0].isOverseadesc = "Y";
            } else {
              vm.formData[0].isOversea = 0;
              vm.formData[0].isOverseadesc = "N";
            }

            vm.formData.lockstaff = res.data.rec[0].lockstaff;
            vm.formData[0].userid = this.$store.getters.userId;

            vm.loading = !vm.loading;
          } else {
            vm.isErr = !vm.isErr;
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },
  },

  async mounted() {
    await this.loadFamilyHandler();
  },
};
</script>